import { Component, OnInit } from '@angular/core';

import { UserService } from '../../services/user-service';
import { SharingService } from "../../services/sharing-service";
import { Alert } from "../../services/alert";
import { AnalyticsService } from '../../services/analytics-service';

@Component({
  selector: 'app-refer-friend',
  templateUrl: './refer-friend.page.html',
  styleUrls: ['./refer-friend.page.scss'],
})
export class ReferFriendPage implements OnInit {

  referralCode?: string

  constructor(
    private userService: UserService,
    public sharingService: SharingService,
    private alert: Alert,
    private analytics: AnalyticsService,
  ) {
    if (userService.user && userService.user.referralCode) {
      this.referralCode = userService.user.referralCode
    } else {
      this.getReferralCode()
    }
  }

  ngOnInit() {
    this.analytics.track(AnalyticsService.ViewReferralScreen)
  }

  // actions

  share() {
    if (!this.referralCode) return;
    this.analytics.track(AnalyticsService.OpenReferralShareDialog)
    this.sharingService.shareReferralCode(this.referralCode)
  }

  // private

  private getReferralCode() {
    this.userService.getReferralCode(
      (code: string) => { this.referralCode = code },
      (errorMsg: string) => { this.error(errorMsg) })
  }

  private error(msg: string) {
    this.alert.show('Error', msg);
  }

}
